export default __webpack_public_path__ + "static/media/add-plus-circle-bold.2d568e58.svg";